import birth_certificate from '../locales/es/birth_certificate.json';
import birth_medical_records from '../locales/es/birth_medical_records.json';
import common from '../locales/es/common.json';
import dna from '../locales/es/dna.json';
import family_info from '../locales/es/family_info.json';
import investigation from '../locales/es/investigation.json';
import investigation_sections from '../locales/es/investigation_sections.json';
import neighborhood_canvas from '../locales/es/neighborhood_canvas.json';
import prospect from '../locales/es/prospect.json';
import religion_info from '../locales/es/religion_info.json';
import residency_questions from '../locales/es/residency_questions.json';
import review from '../locales/es/review.json';
import school_info from '../locales/es/school_info.json';
import review_committee from '../locales/es/review_committee.json';
import social_media from '../locales/es/social_media.json';

export default {
  birth_certificate,
  birth_medical_records,
  common,
  dna,
  family_info,
  investigation,
  investigation_sections,
  neighborhood_canvas,
  prospect,
  religion_info,
  residency_questions,
  review,
  school_info,
  review_committee,
  social_media,
};
